{
  "backButton": "Geri dön: {prevMenuButton}",
  "moreActions": "Daha fazla eylem",
  "unavailable": "Kullanılamıyor, ayrıntıları görmek için genişletin"
}
